import { useMemo, useState } from 'react';

import { useLingui } from '@lingui/react/macro';

import { SectionCardWithHeader } from './common/SectionCardWithHeader';
import { DentalCareSection } from './DentalCareSection';
import { OrthodonticsSection } from './OrthodonticsSection';
import {
  type PlanSummaryView,
  PlanSummaryViewToggle,
} from './PlanSummaryViewToggle';

export const PlanSummarySection = () => {
  const { t } = useLingui();
  const [selectedTab, setSelectedTab] =
    useState<PlanSummaryView>('dental-care');

  const planSummaryContent = useMemo(() => {
    switch (selectedTab) {
      case 'orthodontics':
        return <OrthodonticsSection />;
      case 'dental-care':
      default:
        return <DentalCareSection />;
    }
  }, [selectedTab]);

  return (
    <div id="plan-summary-section" className="vai-mb-8">
      <SectionCardWithHeader
        title={t`Plan Summary`}
        className="vai-w-full"
        headerRight={
          <PlanSummaryViewToggle
            value={selectedTab}
            onChange={setSelectedTab}
          />
        }
      >
        {planSummaryContent}
      </SectionCardWithHeader>
    </div>
  );
};
